// The machine's state in the browser tab and the app switcher ("Bereit · Orione", D-G01 of APP-PARITY.md
// "Detail-Abgleich"); the text comes from core/screens/device.ts.
import { useEffect } from 'react';
import { documentTitle } from '../../core/index.js';
import { useMachine } from '../machine-context.js';

const APP_TITLE = 'Brewcore';

export function DocumentTitle() {
  const { ctx } = useMachine();
  const title = documentTitle(ctx);
  useEffect(() => {
    document.title = title;
  }, [title]);
  useEffect(
    () => () => {
      document.title = APP_TITLE;
    },
    [],
  );
  return null;
}
